import { render, staticRenderFns } from "./LahanUmumMonitoringDua.vue?vue&type=template&id=1b4647e9"
import script from "./LahanUmumMonitoringDua.vue?vue&type=script&lang=js"
export * from "./LahanUmumMonitoringDua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports